import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentEndpoint } from '../constants/shipment-endpoint';
import {
  ShipmentLoadAlertUpdatePayload,
  ShipmentTransportOrderAlertUpdatePayload,
  ShipmentDeliveryNoteAlertUpdatePayload,
  ShipmentWaybillAlertUpdatePayload,
} from '../../models/shipment-common-models';
import { ShipmentListModel, ShipmentStatisticsModel } from '../models/shipment-list/shipment-list.model';
import { ShipmentListSearchCriteria } from '../models/shipment.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentListService {
  constructor(private http: WrapperHttpService) {}

  getShipmentList({
    size,
    page,
    viewMode,
    materialView,
    shipmentStatisticFilter,
    filters,
  }: ShipmentListSearchCriteria): Observable<ShipmentListModel> {
    const url = `${API_URL}${ShipmentEndpoint.Base}`;

    return this.http.withLoading().post<ShipmentListModel>(url, {
      viewMode,
      materialView,
      statisticFilter: shipmentStatisticFilter,
      size,
      page,
      filter: filters,
    });
  }

  getShipmentStatistics({
    size,
    page,
    viewMode,
    shipmentStatisticFilter,
    filters,
  }: ShipmentListSearchCriteria): Observable<ShipmentStatisticsModel> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Statistics}`;

    return this.http.post<ShipmentStatisticsModel>(url, {
      viewMode,
      statisticFilter: shipmentStatisticFilter,
      size,
      page,
      filter: filters,
    });
  }

  updateWaybillAlertList(payload: ShipmentWaybillAlertUpdatePayload): Observable<void> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Alerts}${ShipmentEndpoint.Waybills}`;

    return this.http.withLoading().post<void>(url, payload);
  }

  updateTransportOrderAlertList(payload: ShipmentTransportOrderAlertUpdatePayload): Observable<void> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Alerts}${ShipmentEndpoint.Tos}`;

    return this.http.withLoading().post<void>(url, payload);
  }

  updateLoadAlertList(payload: ShipmentLoadAlertUpdatePayload): Observable<void> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Alerts}${ShipmentEndpoint.Loads}`;
    return this.http.withLoading().post<void>(url, payload);
  }

  updateDeliveryNoteAlertList(payload: ShipmentDeliveryNoteAlertUpdatePayload): Observable<void> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Alerts}${ShipmentEndpoint.DeliveryNotes}`;
    return this.http.withLoading().post<void>(url, payload);
  }
}
